/**
 * Maps the 'language' parameter provided
 * by the consumer app into a valid WebVTT track lang value.
 */
export function parseLanguage(language: string | null) {
  if (!language) return null;
  return language.split('_')[0];
}
